import { TabPane } from 'components/TabPane';

import { forumTabsConfig } from './forumTabsConfig';

export const ForumTabs = () => {
  return <TabPane tabsConfig={forumTabsConfig} />;
};
